import React from "react";
import ReactDOM from "react-dom";
import ScrollableContainer from "../ScrollableContainer/ScrollableContainer";

type QuickSlidesProps = {
    children?: React.ReactNode,
    id: string,
    isOpen: boolean,
    parentElement: string,
    footer: any
}
export const QuickSlides: React.FC<QuickSlidesProps> = ({
                                                            id,
                                                            isOpen,
                                                            parentElement = '[data-testid="scrollable-container"]',
                                                            children,
                                                            footer
                                                        }) => {
    if (!isOpen) {
        return null;
    }

    const parent = (document.querySelector(parentElement) || document.body);

    const modal = (
        <ScrollableContainer id={'quick-slides-scrollable-container'}>
            <div className="quick-slides" id={id}>
                <div className="quick-slides__content">
                    <div className="quick-slides__body">{children}</div>
                    {footer && <div className="quick-slides__footer">{footer}</div>}
                </div>
            </div>
        </ScrollableContainer>
    );
    return ReactDOM.createPortal(modal, parent);
}
